import React, { Component } from 'react';
import { FormattedMessage, injectIntl, useIntl } from 'react-intl';
import DocumentService from '@/shared/services/DocumentService';
import FileIcon from '@/shared/components/FileIcon';
import { listItemMsg } from '@/shared/components/FormattedListValue';
import messages from '../taskMessages';
import { CanRead } from '../../../shared/components/security';
import FormattedDateShort from '../../../shared/components/FormattedDateShort';
import { ModalType, useModalContext } from '@/shared/providers/ModalProvider';

const TaskDetailsSentEmails = ({ emails }) => {
  const intl = useIntl();
  const { setShowModalInfo } = useModalContext();

  return (
    <>
      <div className="margin10T border-top">
        <table className="width100pct margin5T">
          <thead>
            <tr>
              <th>
                <FormattedMessage {...messages.Date} />
              </th>
              <th>
                <FormattedMessage {...messages.Recipients} />
              </th>
              <th>
                <FormattedMessage {...messages.Subject} />
              </th>
              <th>
                <FormattedMessage {...messages.Attachments} />
              </th>
              <th />
            </tr>
          </thead>
          <tbody>
            {emails.map((email, idx) => (
              <tr key={idx} style={{ verticalAlign: 'top' }}>
                <td style={{ padding: '5px' }} className="text-nowrap">
                  <span
                    className="fa-md"
                    style={{ marginRight: '3px' }}
                    title={intl.formatMessage(listItemMsg('emailstatus', email.status))}
                  >
                    {email.status === 2 && <i className="fa fa-info text-info green" />}
                    {email.status === 3 && <i className="fa fa-eye text-info green" />}
                    {email.status === 4 && <i className="fa fa-info text-info red" />}
                  </span>
                  <FormattedDateShort value={email.date} />
                </td>
                <td style={{ padding: '5px' }}>
                  <ul className="list-unstyled">
                    {email.recipients &&
                      email.recipients.map(recipient => <li key={recipient}>{recipient}</li>)}
                  </ul>
                </td>
                <td style={{ padding: '5px' }}>{email.subject}</td>
                <td style={{ padding: '5px' }}>
                  {email.attachments &&
                    email.attachments.map(attachment => (
                      <span
                        className="inline-email-attachment"
                        key={attachment.id}
                        style={{ wordBreak: 'break-all' }}
                      >
                        <span>
                          <CanRead
                            on="Documents"
                            fallback={
                              <span>
                                <FileIcon document={attachment} />
                                {attachment.name}
                              </span>
                            }
                          >
                            <a
                              onClick={() => DocumentService.download(attachment.id)}
                              title={intl.formatMessage(messages.DownloadAttachment)}
                            >
                              <FileIcon document={attachment} />
                              {attachment.name}
                            </a>
                          </CanRead>
                        </span>
                      </span>
                    ))}
                </td>
                <td style={{ padding: '5px' }}>
                  {email.documentId ? (
                    <a
                      className="btn btn-xs btn-default"
                      onClick={e => {
                        setShowModalInfo({
                          modalType: ModalType.DocumentDetail,
                          documentId: email.documentId,
                        });
                        e.stopPropagation();
                      }}
                    >
                      <i className="fa fa-search" />
                    </a>
                  ) : null}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default TaskDetailsSentEmails;
